import React from "react";
import "./style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SectionTitle = ({ icon, title }) => {
  return (
    <div className="event_heading">
      <div className="event_icon">
        <FontAwesomeIcon icon={icon} />
      </div>
      <div>
        <h3>{title}</h3>
      </div>
    </div>
  );
};

export default SectionTitle;
